/*
 * @Author: Json Chen
 * @Date: 2021-07-08 16:11:08
 * @LastEditTime: 2021-07-08 16:11:41
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/config.ts
 */
export const breadcrumbData = ({ getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/settings',
    name: getI18n('general.sider.settings'),
  },
  {
    url: '/settings/logistics',
    name: getI18n('storeLogistics.config.logistics'),
  },
];
